import type { AlbumData } from './albumService';

export type AlbumSortMode = 'title-asc' | 'title-desc' | 'capture-newest' | 'capture-oldest';
export const ALBUM_SORT_STORAGE_KEY = 'family_album_sort_mode_capture_default_v2';
const collator = new Intl.Collator(['ko-KR', 'en-US'], { numeric: true, sensitivity: 'base' });

export function readAlbumSortMode(): AlbumSortMode {
  let saved: string | null = null;
  try { saved = localStorage.getItem(ALBUM_SORT_STORAGE_KEY); } catch { /* Storage can be unavailable. */ }
  if (saved === 'title-asc' || saved === 'title-desc' || saved === 'capture-newest' || saved === 'capture-oldest') return saved;
  if (saved === 'upload-newest') return 'capture-newest';
  if (saved === 'upload-oldest') return 'capture-oldest';
  return 'capture-newest';
}

export function saveAlbumSortMode(mode: AlbumSortMode) {
  try { localStorage.setItem(ALBUM_SORT_STORAGE_KEY, mode); } catch { /* Keep the current UI setting. */ }
}

function captureDateValue(album: AlbumData): number {
  const parsed = Date.parse((album.captureDate || album.createdAt).replaceAll('.', '-').replace(/\s+/g, 'T'));
  return Number.isNaN(parsed) ? 0 : parsed;
}

export function sortAlbums(albums: AlbumData[], mode: AlbumSortMode): AlbumData[] {
  return [...albums].sort((a, b) => {
    if (mode === 'title-asc') return collator.compare(a.title.trim(), b.title.trim()) || collator.compare(a.id, b.id);
    if (mode === 'title-desc') return collator.compare(b.title.trim(), a.title.trim()) || collator.compare(a.id, b.id);
    const compared = mode === 'capture-newest'
      ? captureDateValue(b) - captureDateValue(a)
      : captureDateValue(a) - captureDateValue(b);
    return compared || collator.compare(a.title.trim(), b.title.trim()) || collator.compare(a.id, b.id);
  });
}
